import Vue from 'vue';
import axios from 'axios';

export const pcodeSearch = {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    SEARCH ({}, payload) {
      return new Promise((resolve, reject) => {
        const url = `${process.env.VUE_APP_SEARCH_URL}/postcode?query=`;

        axios.get(url + payload).then((res) => {
          console.dir(res);
          resolve(res.data.data);
        });
      });
    }
  },
  getters: {}
};
